import callCmAPI from 'services/helpers/call-cm-api'
import {
  CustomerGroupT,
  UpdateCustomerGroupDataT,
  WebApi2Response,
} from 'types/global'

export type UpdateCustomerGroupArgs = {
  id: string
  body: UpdateCustomerGroupDataT
}

/**
 * Updates an existing customer group.
 *
 * The patch shape mirrors create — `name`, `description`, and the full
 * `customer_ids` array — minus `created_by`, which is immutable.
 */
export const updateCustomerGroup = ({
  id,
  body,
}: UpdateCustomerGroupArgs): Promise<WebApi2Response<CustomerGroupT>> =>
  callCmAPI(`/customer-group/${id}`, {
    method: 'put',
    data: body,
  }).then(({ data }) => {
    return data
  })
